module.exports = __webpack_public_path__ + "img/sherry.95494e12.png";